import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

export interface QuestionProgress {
  usedQuestionIds: number[];
  currentBlockNumber?: number;
  lastUpdated?: string;
}

export interface QuestionProgressPersistence {
  load(key: string): Promise<QuestionProgress | null>;
  save(key: string, progress: QuestionProgress): Promise<void>;
}

export class FirestoreQuestionProgressPersistence implements QuestionProgressPersistence {
  private userId: string;
  private subcollection: string;

  constructor(userId: string, subcollection = 'questionProgress') {
    this.userId = userId;
    this.subcollection = subcollection;
  }

  async load(key: string): Promise<QuestionProgress | null> {
    try {
      const ref = doc(db, 'users', this.userId, this.subcollection, key);
      const snap = await getDoc(ref);
      if (!snap.exists()) return null;
      return snap.data() as QuestionProgress;
    } catch (error) {
      console.warn('⚠️ Failed to load question progress from Firestore:', error);
      return null; // Gracefully fallback to no progress
    }
  }

  async save(key: string, progress: QuestionProgress): Promise<void> {
    try {
      // Validate data before saving
      if (!this.userId || !key) {
        console.warn('⚠️ Invalid userId or key for Firestore save:', { userId: this.userId, key });
        return;
      }

      // Ensure usedQuestionIds is an array
      const validatedProgress: QuestionProgress = {
        usedQuestionIds: Array.isArray(progress.usedQuestionIds) ? progress.usedQuestionIds : [],
        currentBlockNumber: typeof progress.currentBlockNumber === 'number' ? progress.currentBlockNumber : undefined,
        lastUpdated: progress.lastUpdated || new Date().toISOString()
      };

      const ref = doc(db, 'users', this.userId, this.subcollection, key);
      await setDoc(ref, validatedProgress, { merge: true });
    } catch (error) {
      console.warn('⚠️ Failed to save question progress to Firestore:', error);
      // Don't throw - let the app continue without persistence
    }
  }
}


